import { ArchiveMutation } from "../../hooks/useArchiveState";
import { EducationMaterialControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useEducationMaterialArchive = () =>
  useMutationWithLoading(async (params: ArchiveMutation) =>
    new EducationMaterialControllerApi(
      getConfigObject()
    ).updateEducationMaterialArchiveStatus(
      params?.id,
      params?.status,
      params?.xTENANTID
    )
  );
